export const IS_LOADING = 'IS_LOADING'
export const HAS_UNREAD_MESSAGE = 'HAS_UNREAD_MESSAGE'



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/types.js
// module id = null
// module chunks = 